<div 
  class="upload-area" 
  (click)="triggerFileInput()"
  (dragover)="onDragOver($event)" 
  (dragleave)="onDragLeave($event)" 
  (drop)="onDrop($event)"
>
  <div class="upload-content">
    <img style="content: url('../../../../assets/cloud-upload.svg')" />
    <p class="upload-text">{{ "dragDrop" | translate }}</p>
    <p class="upload-text">{{ "or" | translate }}</p>
    <p class="upload-browse">{{ "browse" | translate }}</p>
    <input 
      #fileInput
      id="fileInput" 
      type="file" 
      multiple 
      (change)="onFileSelected($event)"
      hidden
    />
    <div class="upload-info">
      {{ "maxSizeTotal" | translate }}
    </div>
  </div>
</div>

<div class="upload-list">
  <div *ngFor="let file of files" class="file-item">
    <div style="display: flex; align-items: center;">
      <ng-container [ngSwitch]="file.status">
        <mat-spinner *ngSwitchCase="'uploading'" diameter="24" strokeWidth="3"></mat-spinner>
        <mat-icon *ngSwitchCase="'done'">check</mat-icon>
        <mat-icon *ngSwitchCase="'error'">error</mat-icon>
      </ng-container>
      <div class="file-details">
        <div>{{ file.name }}</div>
        <div class="file-size-container" *ngIf="file.status==='done'">
          <span
            class="uploaded-text"
            [@fadeInOut]="file.showUploaded ? 'visible' : 'hidden'"
          > 
            Uploaded 
          </span>
          <span 
            class="file-size"
            [@fadeInOut]="file.showUploaded ? 'hidden' : 'visible'"
          > 
            {{ formatFileSize(file.size) }}
          </span>
        </div>
      </div>
    </div>
    <mat-icon (click)="removeFile(file)" class="remove-icon">close</mat-icon>
  </div>
</div>